// 身份
export enum IdentityEmun {
  公会长 = 1,
  bd,
  admin,
  运营,
}

export enum TabListEmun {
  '礼包' = 1,
  'BD列表',
  '公会列表',
  '记录',
}
// 特权种类
export enum privilegeType {
  头像框 = 1, // 头像框
  座驾 = 2, // 座驾
  声纹 = 3, // 声纹
  弹幕气泡 = 4, // 弹幕气泡
  房间头像框 = 5, // 房间头像框
  个人资料卡 = 6, // 个人资料卡
  勋章 = 7, // 勋章
}
// 特权种类list
export const categoryList = [
  {label: '头像框', value: privilegeType.头像框},
  {label: '座驾', value: privilegeType.座驾},
  {label: '声纹', value: privilegeType.声纹},
  {label: '弹幕气泡', value: privilegeType.弹幕气泡},
  {label: '房间头像框', value: privilegeType.房间头像框},
  {label: '个人资料卡', value: privilegeType.个人资料卡},
  {label: '勋章', value: privilegeType.勋章},
]
